import React, { memo } from 'react';
import { Tooltip } from '@hose/eui';
import { riskTypeMap, riskColorMap, getRiskComponent } from './utils';
import styles from './RiskWarningItem.module.less';
var RiskWarningBudgetItem = memo(function (props) {
    var _a;
    var _b = props.risk, risk = _b === void 0 ? {} : _b, _c = props.riskType, riskType = _c === void 0 ? '' : _c, _d = props.riskName, riskName = _d === void 0 ? '' : _d, _e = props.riskStatus, riskStatus = _e === void 0 ? '' : _e, _f = props.children, children = _f === void 0 ? null : _f;
    var name = riskName || risk.controlName;
    var type = riskType || risk.type;
    return (React.createElement("div", { className: styles['budget-risk-wrapper'] }, (_a = risk === null || risk === void 0 ? void 0 : risk.prices) === null || _a === void 0 ? void 0 : _a.map(function (item, idx) {
        var _a;
        var componentMap = getRiskComponent();
        var classnames = riskColorMap[type][item.color] || '';
        return (React.createElement("div", { className: styles['risk-warning-item'] + " " + styles[classnames], key: idx },
            React.createElement(RiskWarningItemTitle, { riskType: type, riskName: item === null || item === void 0 ? void 0 : item.name }),
            React.createElement("div", { className: "budget-risk-content" }, ((_a = componentMap[type]) === null || _a === void 0 ? void 0 : _a.call(componentMap, item)) || children)));
    })));
});
export default RiskWarningBudgetItem;
export var RiskWarningItemTitle = function (props) {
    var riskType = props.riskType, riskName = props.riskName;
    return (React.createElement("div", { className: "risk-item-title" },
        React.createElement("span", { className: "risk-tag" }, riskTypeMap()[riskType]),
        riskName && (React.createElement(Tooltip, { title: riskName },
            React.createElement("span", { className: "risk-name" }, riskName)))));
};
